module.exports = __webpack_public_path__ + "static/media/maintenance-hero-21x9.aa64acce.jpg";